import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/** Starts a full import of the team's decisions from Gale, or joins the one running. */
export const startHsaGaleImport = {
  name: "startHsaGaleImport" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ workflowId: z.string() }),
};
